import { render } from "./ExampleQuestions.vue?vue&type=template&id=32c7b69f"
import script from "./ExampleQuestions.vue?vue&type=script&lang=js"
export * from "./ExampleQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__